var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},_vm._l((_vm.menuItems),function(item,index){return _c('div',{key:index,class:['menu-item', { active: _vm.activeIndex === index }],on:{"click":function($event){return _vm.setActive(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }